import React, { useState } from "react"; 
import "./styles.scss";
import { FaStar, FaAngleDown, FaAngleUp } from "react-icons/fa"; 
import NoImage from "../../assets/images/NoImage.png";
 


export default function ReviewCard({ rating }) {

  const [showFullContent, setShowFullContent] = useState(false);

  const toggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  const renderContent = () => {
    if (showFullContent) {
      return rating.content;
    } else {
      const words = rating.content.slice(0, 150);
      return words;
    }
  };

  return (
    <>
      <div className="reviewcard-wrapper">
        <div className="reviewbox">
          <div className="review-header">
            <div className="review-author">
              {rating.image ? (
                <img src={rating.image} alt="img" />
              ) : (
                <img src={NoImage} alt="img" />
              )}
            </div>
            <div className="review-author-info">
              <h5 className="user-name">{rating.name}</h5>
              <h4 className="titel-author">
                {rating.designation}
              </h4>
              <div className="review-stars-rated">
                {/* <Ratings rating={rating.ratings} /> */}
                {/* <i>
                  <FaStar />
                </i>
                <i>
                  <FaStar />
                </i>
                <i>
                  <FaStar />
                </i>
                <i>
                  <FaStar />
                </i>
                <i>
                  <FaStar />
                </i> */}
              </div>
              {/* <span className="rating-count">({rating.review})</span> */}
            </div>
          </div>
          <div className="review-content mt-2">
            {/* <Para>
              {rating.content}
            </Para> */}
            <div className="review-content">
              <p>{renderContent()}{!showFullContent && rating.content.length > 100 && ("....")}</p>
              {!showFullContent && rating.content.length > 150 && (
                <span className="text-primary fw-bold mt-5" onClick={toggleContent}>Read more <FaAngleDown /></span>
              )}
              {showFullContent && rating.content.length > 150 && (
                <span className="text-primary fw-bold mt-5" onClick={toggleContent}>Show less <FaAngleUp /></span>
                // <button className="btn btn-primary btn-sm mt-2" onClick={toggleContent}>Show Less <FaAngleUp /></button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}